import React from 'react';
import { ScrollToDateButton } from '../ConversionBar/ScrollToDateButton';
import { ConversionBarContainerProps } from '../ConversionBarContainer';
import { TicketSelectionIframe } from '../TicketSelectionIframe/TicketSelectionIframe';

type TicketSelectionProps = Pick<
    ConversionBarContainerProps,
    | 'eventName'
    | 'affiliateCode'
    | 'isPreview'
    | 'promoCode'
    | 'waitlistToken'
    | 'rsvpToken'
> & {
    campaignToken: ConversionBarContainerProps['campaign_token'];
    enforceDateAndTimeVisualization: boolean;
};

export const TicketSelection = ({
    affiliateCode,
    campaignToken,
    enforceDateAndTimeVisualization,
    eventName,
    isPreview,
    promoCode,
    rsvpToken,
    waitlistToken,
}: TicketSelectionProps) => {
    if (enforceDateAndTimeVisualization) {
        return (
            <div style={{ padding: '24px' }}>
                <ScrollToDateButton />
            </div>
        );
    }

    return (
        <TicketSelectionIframe
            eventName={eventName}
            affiliateCode={affiliateCode}
            isPreview={isPreview}
            promoCode={promoCode}
            waitlistToken={waitlistToken}
            rsvpToken={rsvpToken}
            campaign_token={campaignToken}
        />
    );
};
